/***start-checkout-click-captcha***/

$("body").on("click",".custom_checkout",function(event) { 
  $('#CartDrawer').addClass('drawer_open')
    // $('.drawer.drawer--right').addClass('drawer--is-open') 
  event.preventDefault();
  var ariLine = $('.cart__items .cart__item.airline_pdp').length;
 $('.captcha_popup').addClass('active')
});
$("body").on("click",".Shopping",function(event) {
  $('.captcha_popup').removeClass('active')
});
/***end-checkout-click-captcha***/


// $(window).scroll(function(){
//     if ($(this).scrollTop() > 310) {
//        $('header.section-header.section-header--flush').addClass('newClass');
//     } else {
//        $('header.section-header.section-header--flush').removeClass('newClass');
//     }
// });

// $(window).scroll(function(){
//     if ($(this).scrollTop() > 310) {
//        $('.custom_header_main').addClass('newClass');
//     } else {
//        $('.custom_header_main').removeClass('newClass');
//     }
// });

var handlelnkdlnHide = setInterval(lnkdlnHide, 100);
function lnkdlnHide(){
     if($(".sk_branding").length > 0){
      $(".sk_branding").remove();
    clearInterval(handlelnkdlnHide);
  }
}


$(document).ready(function(){ 
 
$(".arrow-container .left-arrow svg.arrow-down").click(function () { 
  $(".custom_timelinsec.cstm_timeline").animate({scrollLeft: 1300}, 1300);
  $('.arrow-container').css("right", "-60%" );
  
$('.left-arrow svg.arrow-down').css("display","none");
  $('.left-arrow-scrollbar').css('display',"block");
});

$(".left-arrow-scrollbar").click(function () { 
  $(".custom_timelinsec.cstm_timeline").animate({scrollLeft: 30}, 800);
  $('.left-arrow-scrollbar').css('display',"none");
    $('.arrow-container').css("right", "5px" );
setTimeout(function() {
  $('.left-arrow svg.arrow-down').css("display","block");
},200);
   
    
});

  setTimeout(function() {
    $('#cstm_rewards.btn').on('click',function(e){
      e.preventDefault();
      $(".swell-tab:eq(0)").trigger("click");
    });
  }, 2000);

  $(".cstm_button").click(function() {
    $(this).addClass("active");

  });

  /*
    $('.iWishAddColl').on('click',function(e){
      e.preventDefault();
    var iWishvId = jQuery(this).attr("data-variant");
      iwish_addCollection(jQuery(this), iWishvId);
      iWishCounter();
      return false;

    });
    */
  /*
  * @check notify button in product page is exist and hide default.
  */
  var storeTimeInterval = setInterval(function(){ if ($('#BIS_trigger').length > 0 ) { $('#BIS_trigger').parent("div").hide();  clearInterval(storeTimeInterval); }},1000);

  $('.cstmoption2').on('click',function(){
    var findClass= $(this).children('input');
    if(findClass.hasClass('disabled')){  $('#BIS_trigger').parent("div").show(); }else{ $('#BIS_trigger').parent("div").hide(); }

    setTimeout(function(){ 
      var cval = $('.cstm_var_option option:selected').attr('data-policy');
      var cstatus = $('.cstm_var_option option:selected').attr('data-status');
 var cQuantity = $('.cstm_var_option option:selected').attr('data-quantity');

      if(cval=='deny' && cstatus=='available'){
        $('.cstm_preorder_text').css('display','none');
        $('.add-to-cart').find('span').text('Add To Cart');
        $('.cstmoption1').find('label').removeClass('disabled');
        $('.cst_Add').removeAttr('disabled');
      }
      else if(cval=='deny' && cstatus=='Sold Out')
      {
        $('.cstm_preorder_text').css('display','none');
        $('.add-to-cart').find('span').text('Sold Out');
        $('.cstmoption1').find('label').addClass('disabled');
        $('.cst_Add').attr('disabled','disabled');
      }
       else if(cval=='continue' && cstatus=='available' && cQuantity > 0){
        $('.cstm_preorder_text').css('display','none');
        $('.add-to-cart').find('span').text('Add To Cart');
        $('.cstmoption1').find('label').removeClass('disabled');
        $('.cst_Add').removeAttr('disabled');
      }
      else if(cval=='continue' && cstatus=='available' && cQuantity <= 0){
      $('.cstm_preorder_text').css('display','block');
        $('.add-to-cart').find('span').text('Pre-Order');
        $('.cstmoption1').find('label').removeClass('disabled');
        $('.cst_Add').removeAttr('disabled');
      }
    },100);

  });
  $( window ).on('load',function() {
    var cval = $('.cstm_var_option :selected').attr('data-policy');
    var cstatus = $('.cstm_var_option option:selected').attr('data-status');
 var cQuantity = $('.cstm_var_option option:selected').attr('data-quantity');

    if(cval =='deny' && cstatus =='available'){
      $('.cstm_preorder_text').css('display','none');
      $('.add-to-cart').find('span').text('Add To Cart');
      $('.cstmoption1').find('label').removeClass('disabled');
      $('.cst_Add').removeAttr('disabled');
    }
    else if(cval=='deny' && cstatus=='Sold Out')
    {
      $('.cstm_preorder_text').css('display','none');
      $('.add-to-cart').find('span').text('Sold Out');
      $('.cstmoption1').find('label').addClass('disabled');
      $('.cst_Add').attr('disabled','disabled');
    }
      else if(cval=='continue' && cstatus=='available' && cQuantity > 0){
        $('.cstm_preorder_text').css('display','none');
        $('.add-to-cart').find('span').text('Add To Cart');
        $('.cstmoption1').find('label').removeClass('disabled');
        $('.cst_Add').removeAttr('disabled');
      }
      else if(cval=='continue' && cstatus=='available' && cQuantity <= 0){
      $('.cstm_preorder_text').css('display','block');
      $('.add-to-cart').find('span').text('Pre-Order');
      $('.cstmoption1').find('label').removeClass('disabled');
      $('.cst_Add').removeAttr('disabled');
    }
  });

  $(".cstm_shopthelook__Dot").click(function(){
    if ($(window).width() <= 991){
      $(".cstm_mobviewproduct").trigger("click");
    }


  });

});

$('body').on('click', '.custom-product-swatch', function(e) {
  e.preventDefault();
    var url = $(this).attr('data-handle');
    $.ajax({
        url: $(this).attr('data-handle') + '/?view=recommend-products',
        method: "GET"
      })
      .done(function(data) {
           $("main").html(data);   
         window.history.pushState({}, null, url);
        localStorage.setItem("PrevLocation", url);
     
 }).fail(function(error) {
        console.log(error);
      });


});





var divCheckingInterval = setInterval(function(){
    // Find it with a selector
    if(document.querySelector(".yotpo-display-wrapper")){
$("a.text-m").each(function(){
var get_text = $(this).text(); 
    //console.log(get_text);
    var split_value = get_text.split(" ");
    const first = split_value[0];
    var barcket_value = "("+first+")";
 //console.log(barcket_value);
  $(this).text(barcket_value);
  
  
});
      //  console.log("Found!");
        clearInterval(divCheckingInterval);
        // Do something
    }
}, 500);

$(document).ready(function(){ 
  $("body").on("click",".plus_wrappper",function(event) {
    $(this).parent().parent().find('.max_quanity_messgae').show();    
});
});
$("body").on("click",".airline_price_remaining",function(event) {
   $('.custom_ful_page_loading').show();
   var remaining_item = $(this).attr("pro-id");
   var thisitem = $(this);
    var airline1 = $("input[name='properties[_airlines]']").val();
      var airlineprice1 = $("input[name='properties[_airlines_price]']").val();
       var airlineprice2 = $("input[name='properties[_airlines_customer_price]']").val();
 // $(".custom_inner_spinner").show();
  jQuery.ajax({
    type: 'POST',
    url: '/a/airlines/Nora-Airlines-addon/productCreate.php',
    data:{
      properties: remaining_item
    },
    dataType: 'json',
    success: function(productid){
         var cusrent_pro = $(".cstm_var_option").val(); //$(thisitem).attr("original_pro");
        jsonObj = [];
     item= {}    
    item['quantity'] = 1;  
      item['properties'] = {"_airlines":airline1,"_airlines_price":airlineprice1,"_airlines_customer_price":airlineprice2}; 
       
    item['id'] = parseInt(cusrent_pro);
         jsonObj.push(item);
        item = {}
       item['properties'] = {"_custom_pro":"Product Charges","_product_id":cusrent_pro};  
        item['quantity'] = 1;  
    item['id'] = parseInt(productid);
      jsonObj.push(item);
      $('.errors.custm-error').remove();
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {items: jsonObj},
    dataType: 'json',
    success: function(productid2){
      getCartShippingAirlines();
     
 document.dispatchEvent(new CustomEvent('cart:build'));
     // $(".custom_inner_spinner").hide();
     
      $(".main_airline_price_remaining").hide();
      
      $(".airline_price_compare").show();
      if($("#CartDrawer.drawer--right").hasClass(".drawer--is-open")==false){
        $(".cart-link__bubble").trigger("click");
      }
   
    },
    error:function(e){
       $(".custom_inner_spinner").hide();
      $('.payment-buttons.cstm_payment').append(`<div class="errors custm-error text-center">${e.responseJSON.description}</div>`)
    setTimeout(function(){$('.errors.custm-error').remove()},8000);
    
       }
  });
       $('.custom_ful_page_loading').hide();
    },

  });
});

$(document).on("click",".airline_pdp .js-qty__adjust--minus", function() {
  var $this = $(this);
   var main_pro_id = $(this).parents(".airline_pdp").attr("data-pro-id");
  setTimeout(function() {
      $(".cust_pro[data-prop='"+main_pro_id+"']:not([data-ship='airlines']) .js-qty__adjust--minus").trigger("click");
    
  },1000);
  
});


$("body").on("click",".airline_pay_to_purchase",function(event) {
 $('.custom_ful_page_loading').show();
    var remaining_item = $(this).attr("pro-id");
     var airline1 = $("input[name='properties[_airlines]']").val();
      var airlineprice1 = $("input[name='properties[_airlines_price]']").val();
       var airlineprice2 = $("input[name='properties[_airlines_customer_price]']").val();
   //110
  //cart shipping charge already added do nothing else create the product charge with price //remaining_item + 14.99
   var thisitem = $(this);
 // $(".custom_inner_spinner").show();
  jQuery.ajax({
    type: 'POST',
    url: '/a/airlines/Nora-Airlines-addon/productCreate.php',
    data:{
      properties: remaining_item
    },
    dataType: 'json',
    success: function(productid){
         var cusrent_pro = $(".cstm_var_option").val(); //$(thisitem).attr("original_pro");
        jsonObj = [];
     item= {}    
    item['quantity'] = 1;  
     item['properties'] = {"_airlines":airline1,"_airlines_price":airlineprice1,"_airlines_customer_price":airlineprice2}; 
    item['id'] = parseInt(cusrent_pro);
         jsonObj.push(item);
        item = {}
       item['properties'] = {"_custom_pro":"Product Charges","_product_id":cusrent_pro};  
        item['quantity'] = 1;  
    item['id'] = parseInt(productid);
      jsonObj.push(item);
      $('.errors.custm-error').remove();
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {items: jsonObj},
    dataType: 'json',
    success: function(productid2){
      getCartShippingAirlines();
  document.dispatchEvent(new CustomEvent('cart:build'));
     if($("#CartDrawer.drawer--right").hasClass(".drawer--is-open")==false){
        $(".cart-link__bubble").trigger("click");
      }
      //$(".custom_inner_spinner").hide();
      $(".custom_btn").hide();
     
      
    },
    error:function(e){
      // $(".custom_inner_spinner").hide();
      $('.payment-buttons.cstm_payment').append(`<div class="errors custm-error text-center">${e.responseJSON.description}</div>`)
    setTimeout(function(){$('.errors.custm-error').remove()},8000);
    
       }
  });
       $('.custom_ful_page_loading').hide();
    },

  });
});
 $('<p style= "color: #ccb186 !important;" class="custom_left_move_message">Please scroll left to right <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#ccb186" d="m11.71 15.29l2.59-2.59a.996.996 0 0 0 0-1.41L11.71 8.7c-.63-.62-1.71-.18-1.71.71v5.17c0 .9 1.08 1.34 1.71.71z"/></svg></p>').insertAfter(".table_main");
$('button.measure_btn').click(function () {
  $('.popup').show();
 });
$('a.cus_cross_icon').click(function () {
 $('.popup').hide();
 });
$('td.size-head').attr('colspan','4');
//popup//

  //   $ = function (id) {
  //   return document.getElementById(id);
  // };

  // var show = function (id) {
  //   $(id).style.display = "block";
  // };
  // var hide = function (id) {
  //   $(id).style.display = "none";
  // };

// $(".measure_btn").click(function() {
//   $(".Size_chart_popup_jtpl").fadeIn(500);
// });
// $(".cus_cross_icon").click(function() {
//   $(".Size_chart_popup_jtpl").fadeOut(500);
// });

// why choose us section image height
$(window).on('load resize scroll', function(){
  var chooseHeight = $('.cstm-jtpl-choose-us-sct .grid__item:first-child .image-wrap img').height();
  $('.cstm-jtpl-choose-us-sct .grid__item > div').css('height', chooseHeight);
});
$("body").on("click",".custom_return",function(event) {
 var modal = $('#myModal');
      // alert('You clicked on the "Start a Return or Exchange" link.');
      event.preventDefault();
    modal.css('display', 'block');
    $('body').addClass('modal-open');
  
    
})
$("body").on("click",".close",function(event) {
  var modal = $('#myModal');
   modal.css('display', 'none');
    $('body').removeClass('modal-open');
})
$(window).click(function(event) {
   var modal = $('#myModal');
      if ($(event.target).is(modal)) {
        modal.css('display', 'none');
         $('body').removeClass('modal-open');
      }
    });
document.addEventListener('cart:build', () => {
   $('.custom_ful_page_loading').show();
  $.ajax({
    type: "GET",
    url: '/cart.js',
    dataType: 'json',
    success: function(resp) {
      if (resp.item_count === 0) {
        var nullHash = {};
        for ([key, value] of Object.entries(resp.attributes)) {    
            nullHash[key] = null;
        }
      }else{     
        var nullHash = {};
        for ([key, value] of Object.entries(resp.attributes)) {    
            nullHash[key] = null;
        }
         $.ajax({
            type: "POST",
            async : false,
            url: '/cart/update.js',
            data: {attributes:nullHash},
            dataType: 'json'
        });
            // Loop through the items in the cart
            resp.items.forEach(function(item) {
                var variantId = item.variant_id;
                var airlinePrice = item.properties._airlines_price || 0; // Get price from _airlines_price property
                var customerPrice = item.properties._airlines_customer_price || 0; // Get price from _airlines_customer_price property
                var quantity = item.quantity;
               if(item.properties._shipping == "airlines"){
                 airlinePrice = 24.99;
              }
              
              if(airlinePrice == 0){
                airlinePrice = item.price/100;
              }
                // Format the data in the required format: "variantid~airline_price~quantity~customer_price"
                var formattedData = variantId + '~' + airlinePrice + '~' + quantity + '~' + customerPrice;
                  console.log(formattedData);
                // Update the cart attributes with the formatted data
                nullHash[variantId] = formattedData;
            });
      }
        $.ajax({
            type: "POST",
            url: '/cart/update.js',
            data: {attributes:nullHash},
            dataType: 'json'
        });
      
    }
});
  $('.custom_ful_page_loading').hide(); 
});

$(document).ready(function(){ 
$.ajax({
    type: "GET",
    url: '/cart.js',
    dataType: 'json',
    success: function(resp) {
      if (resp.item_count === 0) {
        var nullHash = {};
        for ([key, value] of Object.entries(resp.attributes)) {    
            nullHash[key] = null;
        }
      }else{     
        var nullHash = {};
        for ([key, value] of Object.entries(resp.attributes)) {    
            nullHash[key] = null;
        }
         $.ajax({
            type: "POST",
            async : false,
            url: '/cart/update.js',
            data: {attributes:nullHash},
            dataType: 'json'
        });
            // Loop through the items in the cart
            resp.items.forEach(function(item) {
                var variantId = item.variant_id;
                var airlinePrice = item.properties._airlines_price || 0; // Get price from _airlines_price property
                var customerPrice = item.properties._airlines_customer_price || 0; // Get price from _airlines_customer_price property
                var quantity = item.quantity;

              if(item.properties._shipping == "airlines"){
                 airlinePrice = 24.99;
              }
              
              if(airlinePrice == 0){
                airlinePrice = item.price/100;
              }
                // Format the data in the required format: "variantid~airline_price~quantity~customer_price"
                var formattedData = variantId + '~' + airlinePrice + '~' + quantity + '~' + customerPrice;
                  console.log(formattedData);
                // Update the cart attributes with the formatted data
                nullHash[variantId] = formattedData;
            });
      }
        $.ajax({
            type: "POST",
             async : false,
            url: '/cart/update.js',
            data: {attributes:nullHash},
            dataType: 'json'
        });
      
    }
});
  
});
